export{IconComponent,IconSize}from"./icon.component.js";
//# sourceMappingURL=index.js.map
